import React from 'react';
import Slider from "react-slick";
import styled from '@emotion/styled';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { mq, green01, green02, breakP, fastDurationTime, hoverFade } from '../../_style';

import ColumnItem from '../molecules/columnItem';
import { css } from '@emotion/core';

const Container = styled.div`
  .slick-slider {
    ${mq.pc} {
      padding-bottom: 60px;
    }
  }
  .slick-track {
    display: flex;
    align-items: stretch;
  }
  .slick-slide {
    float: none;
    height: auto;
    ${mq.pc} {
      padding-right: 24px;
      transition: opacity ${fastDurationTime} ease;
      &:not(.slick-active) {
        opacity: 0.4;
        pointer-events: none;
      }
    }
    ${mq.sp} {
      width: 313px !important;
      padding-right: 30px;
    }
    > div {
      height: 100%;
    }
  }
  .slick-list {
    overflow: visible;
    ${mq.pc} {
      margin-right: -24px;
    }
  }
  .slick-arrow {
    color: ${green01};
    width: 21px;
    height: auto;
    padding: 4px 0;
    top: auto;
    bottom: 0;
    transform: none;
    transition: color ${fastDurationTime} ease;
    &:hover {
      color: ${green02};
    }
    &::before {
      display: none;
    }
    ${mq.sp} {
      display: none;
    }
  }
  .slick-prev {
    right: 50px;
    left: auto;
  }
  .slick-next {
    right: 0;
  }
`;

const arrowStyle = css`
  position: absolute;
  bottom: 0;
  cursor: pointer;
  ${hoverFade}
  svg {
    fill: ${green01}
  }
`

const NextArrowContainer = styled.button`
  ${arrowStyle}
  right: 0;

`
const PrevArrowContainer = styled.button`
  ${arrowStyle}
  right: 52px;
`

function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <NextArrowContainer onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="21.79" height="11.67" viewBox="0 0 21.79 11.67"><path d="M0 5.33h20L15.79.67l.74-.67 5.26 5.83-5.26 5.84-.74-.67L20 6.33H0v-1z"/></svg>
    </NextArrowContainer>
  );
}

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <PrevArrowContainer onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="21.79" height="11.67" viewBox="0 0 21.79 11.67"><path d="M21.79 5.33H1.8L6 .67 5.26 0 0 5.83l5.26 5.84L6 11 1.8 6.33h19.99v-1z"/></svg>
    </PrevArrowContainer>
  );
}

const settings = {
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [{
    breakpoint: breakP,
    settings: {
      infinite: false,
      arrows: false,
      variableWidth: true,
      slidesToShow: 1,
    },
  }],
};

export default class ColumnSlider extends React.Component {
  render() {
    const items = this.props.items.slice(0, 5);
    return(
      <Container>
        <Slider {...settings}>
          {items.map((item, i) => (
            <ColumnItem key={i} to={item.link} thumb={item.thumb}>{item.title}</ColumnItem>
          ))}
        </Slider>
      </Container>
    );
  }
};
